<app-card-lg [title]="'Recipes'" >
  <div *appLoading="loading$ | async"></div>
  @if(!(loading$ | async)) {
    @for(recipe of (recipes$ | async); track recipe ) {
      <app-recipes-list-item [recipe]="recipe"></app-recipes-list-item>
    }
  }
</app-card-lg>
